/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductAttributeService = {
  async getAttributeTableDefinition() {
    const requestScreenData = {
      url: "api/AttributeTableDefinition",
      filter: "AttributeTableName eq 'StorageLocationAttribute'",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getAttributeColumnDefinition(filter) {
    const requestScreenData = {
      url: "api/AttributeColumnDefinition",
      select:
        "AttributeName,DefaultValue,DisplayName,IsRequired,RecordId,AttributeTableDefinitionRecordId",
    };

    if (filter) requestScreenData.filter = filter;

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/AttributeColumnValueLookup",
      top: "1",
      filter: `RecordId eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(mode, payload, RecordId) {
    var url = "api/AttributeColumnValueLookup";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.patch(url, RecordId, payload, "Guid");
    }
  },
  async saveLocation(mode, payload, RecordId) {
    var url = "api/StorageLocation";

    return await ApiService.post(url, payload, "Guid");
  },

  async getLocationByCode(code) {
    const requestScreenData = {
      url: "api/StorageLocationList",
      top: "1",
      filter: `RecordId eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { ProductAttributeService };
